// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__swsxw","left":"Virtual_left__LPxIv","wrapper":"Virtual_wrapper__B1An-"};